<template>

    <dialog id="my_modal_2" class="modal app-container" :open="isModalOpen">
        <div class="modal-box text-center bg-gray-200 w-[95%] sm:w-[85%] md:w-[65%] mx-auto overflow-hidden">

            <!-- Empty Order -->
            <p v-if="getOrderArticles.length < 1" class="mt-4 text-lg font-semibold text-gray-600">
                No tiene articulos seleccionados
            </p>


            <!-- Order Articles -->
            <div class="overflow-x-auto">
                <table v-if="getOrderArticles.length > 0" class="w-full rounded-lg">
                    <thead class="bg-gray-400/50 mb-5 rounded-lg">
                        <tr>
                            <th scope="col"
                                class="py-3.5 px-4 text-sm  text-left rtl:text-right text-gray-500">
                                <div class="flex items-center gap-x-3">
                                    <span class="font-bold">SKU</span>
                                </div>
                            </th>

                            <th scope="col"
                                class="font-bold px-4 py-3.5 text-sm  text-left rtl:text-right text-gray-500">
                                Marca
                            </th>

                            <th scope="col"
                                class="font-bold px-4 py-3.5 text-sm  text-left rtl:text-right text-gray-500">
                                Descripcion
                            </th>

                            <th scope="col"
                                class="capitalize font-bold px-4 py-3.5 text-sm text-left rtl:text-right text-gray-500">
                                cantidad
                            </th>

                        </tr>
                    </thead>
                    <tbody
                        class="bg-gray-300 divide-y divide-gray-200 rounded-lg">

                        <ArticleOrder v-for="articulo in getOrderArticles" :key="articulo.cod_articulo"
                            :articulo="articulo" />

                    </tbody>
                </table>

            </div>

            <div class="flex justify-end mt-3">
                <button @click="closeModal"
                    class="btn bg-gray-300 border border-gray-400/20 hover:border-gray-400">Close</button>
            </div>
        </div>
    </dialog>


    <div v-if="isModalOpen" class="modal-backdrop fixed top-0 left-0 z-10 bg-black opacity-40 w-screen h-screen"></div>

</template>




<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import ArticleOrder from '../../TableArticules/ArticleOrder.vue';
import { useOrderStore } from '../../TableArticules/store/Order.store';
import { useCancelOrder } from '../../ConfirmOrderDetail/Composables/cancel-order';



interface Props {
    open: boolean
    dropdown: boolean
}

const props = defineProps<Props>();


const emit = defineEmits([
    'update:open',
    'update:dropdown'
])


const orderStore = useOrderStore()

const getOrderArticles = computed(() => orderStore.getOrderArticles)

const isModalOpen = ref(props.open);

const { cancelOrder } = useCancelOrder()




watch(() => props.open, (newValue) => {
    isModalOpen.value = newValue
})

watch(isModalOpen, (newValue) => {
    emit('update:open', newValue)
})





const closeModal = () => {
    isModalOpen.value = !isModalOpen.value
    emit('update:dropdown', false)
    getOrderArticles.value.length < 1 ? cancelOrder() : window.location.reload()
}




</script>



<style scoped>
.modal-box {
    /* Eliminamos el max-width fijo */
    position: relative;
    margin: 1.5rem auto;
    max-height: calc(100vh - 4rem); /* Para evitar que exceda la pantalla */
    border-radius: 0.5rem;
}

/* Agregamos media queries para ajustar padding en móviles */
@media (max-width: 640px) {
    .modal-box {
        padding: 1rem;
        margin: 1rem;
    }
}
</style>